import { Navigate } from 'react-router-dom';

/** Deposit / cashout forms live in the Telegram bot, not the Mini App. */
export function BotMoney() {
    return <Navigate to="/profile" replace />;
}
